import React, { useState, useEffect, useContext } from "react";
import { useParams, useNavigate, Outlet, useLocation } from "react-router-dom";
import { ContentContainer, createDialog, QuestionDialog } from "coaz-ui";
import { PiGraduationCapLight } from "react-icons/pi";
import { GlobalContext } from "../contexts/GlobalContext";
import client from "../client";
import AddProgram from "./AddProgram";
import LoadingIcons from "react-loading-icons";
import Card from "./Card";
import ResponsiveChildren from "./ResponsiveChildren";

const Programs = () => {
	const { version, setVersion } = useContext(GlobalContext);
	const [programs, setPrograms] = useState([]);
	const [buttons, setButtons] = useState([]);
	const [loading, setLoading] = useState(true);
	const [deleteAuthority, setDeleteAuthority] = useState(true);
	const { programId } = useParams();
	const { request, errorMessage } = client;
	const path = useLocation().pathname;

	const getPrograms = async () => {
		try {
			const response = await request("GET", "programs");

			const list = Array.isArray(response) ? response : response?.content;
			setPrograms(list ?? []);
		} catch (error) {
			console.log(error);
			setPrograms([]);
		}
	};

	const onAddProgram = () => {
		createDialog({
			title: "Add Program",
			Component: AddProgram,
			version: version,
			setVersion: setVersion,
		});
	};

	const navigate = useNavigate();

	const onOpen = (e,id) => {
		e.preventDefault();
		e.stopPropagation();
		if(!id) return;
		navigate(`${path}/_program/${id}`);
	}

	const onDelete = (e,id) => {
		e.preventDefault()
		e.stopPropagation();
		if (!id) return;

		createDialog({
			title: "Delete Program",
			submitText: "Yes",
			cancelText: "No",
			Component: QuestionDialog,
			params: {
				message: `Are you sure you want to delete this program?`,
				submit: async () => {
					try {
						await request("DELETE", `programs/${id}`);
						return { message: "Successful", success: true };
					} catch (error) {
						return { message: errorMessage(error) };
					}
				},
			},
			version: version,
			setVersion: setVersion,
		});
	};


	const load = async () => {
		setLoading(true);

		const current = await client.getCurrent();
		const createProgram = current?.authorities?.find((auth) => auth.authority === "PROGRAM:CREATE");
		const deleteProgram = current?.authorities?.find((auth) => auth.authority === "PROGRAM:DELETE");
		setButtons(createProgram ? [{ Icon: PiGraduationCapLight, name: "Add Program", handler: onAddProgram }] : []);
		setDeleteAuthority(!!deleteProgram);

		await getPrograms();
		setLoading(false);
	};

	useEffect(() => {
		load();
	}, [version]);

	return (
		<>
			{programId ? (
				<Outlet />
			) : (
				<ContentContainer
					buttons={buttons}
					Icon={PiGraduationCapLight}
					text="Programs"
					scrollable={true}
					loading={false}
				>
					<ResponsiveChildren>
						{programs.map((program, index) => (
							<Card
								key={program.ref?.id ?? index}
								id={program.ref?.id ?? index}
								heading={program.name}
								body={program.description}
								image={`${process.env.PUBLIC_URL}/images/program.jpg`}
								onOpen={onOpen}
								actionText="Delete"
								onAction={deleteAuthority && onDelete?onDelete : undefined}
							/>
						))}
					</ResponsiveChildren>
				</ContentContainer>
			)}
		</>
	);
};

export default Programs;
